<template>
    <md-card style="margin-bottom: 20px;">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="deliveryNote">Delivery note</label>
              <md-input type="text" v-model="filtri.deliveryNote" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="sap">SAP</label>
              <md-input type="text" v-model="filtri.sap" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="depot">Magazino</label>
              <md-select name="depot" v-model="filtri.depot">
                  <md-option value="0">Tutti</md-option>
                  <md-option value="1">Goriziana</md-option>
                  <md-option value="2">Klaut</md-option>
                  <md-option value="3">Mar</md-option>
                  <md-option value="4">K-Marmi</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="elogate">ELOGATE</label>
              <md-input type="text" v-model="filtri.elogate" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="transportMean">Transport mean</label>
              <md-input type="text" v-model="filtri.transportMean" />
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="dateBlock">
            <label for="orderDate">Order Date</label>
            <div class="md-layout">
                <div class="md-layout-item maxwidth220">
                  <md-datepicker v-model="filtri.orderDateFrom" md-immediately>
                      <label for="orderDateFrom">Da</label>
                  </md-datepicker>
                </div>
                <div class="md-layout-item maxwidth220">
                  <md-datepicker v-model="filtri.orderDateTo" md-immediately>
                      <label for="orderDateTo">A</label>
                  </md-datepicker>
                </div>
            </div>
          </div>
          <div class="dateBlock">
            <label for="orderDate">Delivery Date</label>
            <div class="md-layout">
                <div class="md-layout-item maxwidth220">
                  <md-datepicker v-model="filtri.deliveryDateFrom" md-immediately>
                      <label for="deliveryDateFrom">Da</label>
                  </md-datepicker>
                </div>
                <div class="md-layout-item maxwidth220">
                  <md-datepicker v-model="filtri.deliveryDateTo" md-immediately>
                      <label for="deliveryDateTo">A</label>
                  </md-datepicker>
                </div>
            </div>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-raised" @click="filter()">{{label}}</md-button>
        <md-button class="md-raised" @click="reset()">Azzera</md-button>
      </md-card-actions>
    </md-card>
</template>

<script>

  export default {
    name: 'CaricoFiltri',
    props: ['buttonLabel'],
    data: () => ({
      depots: {},
      label: 'Filtra',
      filtri: {
        deliveryNote: '',
        depot: 0,
        orderDateFrom: '',
        orderDateTo: '',
        deliveryDateFrom: '',
        deliveryDateTo: '',
        sap : '',
        elogate : '',
        transportMean : '',
        reset : false
      },
    }),
    mounted() {
      this.depots = window.appCfg.depots
      if (this.buttonLabel) this.label = this.buttonLabel
    },
    methods: {
      filter() {
        this.filtri.reset = false
        this.$emit('ricerca-ordini', this.filtri)
      },
      reset() {
        this.filtri = {
          deliveryNote: '',
          depot: 0,
          orderDateFrom: '',
          orderDateTo: '',
          deliveryDateFrom: '',
          deliveryDateTo: '',
          sap : '',
          elogate : '',
          transportMean : '',
          reset : true
        }
        this.$emit('ricerca-ordini', this.filtri)
      }
    }
  }

</script>

<style lang="css" scoped>

  .md-table + .md-table {
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/CaricoFiltri.vue